module.exports = {
      id: "edit-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-5579a9c22c9b0e56875750544888299d.svg#edit",
      toString: function () {
        return this.url;
      }
    }